<!-- license validity -->
@if (installerAccessUntil() || showLicenseStatus()) {
  <ion-grid class="ion-no-margin ion-margin-top ion-no-padding">
    <ion-row class="ion-margin-vertical ion-no-padding">
      <ion-col
        class="credits ion-padding"
        size-xs="12"
        size-sm="12"
        size-md="12"
      >
        <ion-grid>
          <ion-row>
            <ion-col>
              <p>
                <b>{{ 'installation_until' | translate }}</b>
              </p>
              @if (showUnlimited()) {
                <h2 class="smaller">
                  {{ 'license_unlimited' | translate }}
                </h2>
              } @else if (installerAccessUntil()) {
                <h2 class="smaller">{{ installerAccessUntil() | date }}</h2>
              } @else {
                <h2 class="smaller">—</h2>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
}

@if (!showUnlimited()) {
  <ng-container>
    <p class="license-subtitle">{{ optionsLabel() | translate }}</p>

    <!-- product overview -->
    <div class="products-grid">
      @for (product of filteredProducts(); track product.uid) {
        <div
          class="product-card"
          [class.active]="product.isSelected"
          (click)="onProductSelected(product)"
        >
          <div class="license-badge">{{ product.name | translate }}</div>
          <div class="license-price">&euro;{{ product.price }}</div>
          @if (product.stockCount > 0) {
            <div class="license-stock-badge">
              {{ product.stockCount }}
              {{ 'licenses_licenseInStock' | translate }}
            </div>
          }
          <p
            class="license-description"
            [innerHTML]="product.info ?? '' | translate"
          ></p>
        </div>
      }
    </div>

    <!-- buttons -->
    <div class="payment-actions">
      @if (showPrevButton()) {
        <button
          class="btn-action btn-action-prev"
          type="button"
          (click)="prevClicked.emit()"
        >
          {{ 'general_prev' | translate }}
        </button>
      }
      <div class="payment-actions-right">
        @if (selectedStockCount() > 0) {
          <button
            class="btn-action btn-action-stock"
            type="button"
            (click)="submitFromStock()"
          >
            {{ 'installation_fromStockComplete' | translate }}
          </button>
        }
        <button
          class="btn-action btn-action-next"
          type="submit"
          (click)="submitProduct()"
        >
          {{ buyButtonLabel() | translate }}
        </button>
      </div>
    </div>
  </ng-container>
}
